module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.answer) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("Descripción:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v(_vm._s(_vm.answer.description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fecha y hora:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.answer.dateComments))])]), _vm._v(" "), (_vm.answer.idRefenceTo) ? _c('tr', [_c('th', [_vm._v("En respuesta a:")]), _vm._v(" "), _c('td', _vm._l((_vm.comments), function(item, index) {
    return _c('span', [(item.idComments === _vm.answer.idRefenceTo) ? _c('font', [_vm._v(_vm._s(item.description))]) : _vm._e()], 1)
  }), 0)]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.answer) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('router-link', {
    class: 'btn btn-primary btn-lg',
    attrs: {
      "to": "/allComments",
      "tag": "button"
    }
  }, [_vm._v("Ver todos los mensajes")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v("Comentario no encontrado")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4826ec0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CommentDetail.vue
// module id = 659
// module chunks = 1